import {
  Box,
  Grid,
} from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import { LoadingButton } from "@mui/lab";
import { useDispatch, useSelector } from "react-redux";
import { productStartManufacturing } from "../../../slices/manufacturer";
import FormikControl from "../FormikControl";
import { selectCurrentCycle } from "../../../slices/common";

const initialValues = {
  blood_amount: "",
};




const StartManufacturingForm = (
  formProps
) => {
  const dispatch = useDispatch();
  // const { id, feasibility_id } = useParams();
    const currentCycle = useSelector(selectCurrentCycle)

const validationSchema = Yup.object().shape({
 blood_amount: Yup.string().required("Please enter required blood amount")
  .test(
      'max-amount',
      function(value) {
        const maxAmount = currentCycle?.remaining_blood;
        if (maxAmount === undefined || maxAmount === null) {
          return true; // No max limit set
        }
        if (parseFloat(value) > parseFloat(maxAmount)) {
          return this.createError({
            message: `Amount must be less than or equal to ${maxAmount} ml`
          });
        }
        return true;
      }
    ),
});

  const handleSubmit = async (values) => {
    try {
      // Prepare API payload with the selected restart option
      const payload = {
        subject_id: formProps?.subject_id,
        feasibility_assessment_id: currentCycle?.feasibility_assessments_id,
        product_manufacturing_stages_id: currentCycle?.product_manufacturing_id,        
        qr_code_generated_id: formProps?.qr_code_generated_id,
        blood_amount: values.blood_amount
      };
        const res = await dispatch(productStartManufacturing(payload)).unwrap();
      if (res?.status === 200) {
        formProps.handleFormSubmit();
      }
    } catch (err) {
      console.error("Error restarting manufacturing:", err);
    }
  };

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: handleSubmit,
  });

  const formOptions = [
        {
          label: 'Total Blood Received',
          type: 'number',
          disabled:true,
          placeholder: currentCycle?.remaining_blood || 0,
          extraContent:'ml'
        },
        {
          label: 'Required Blood Amount',
          type: 'number',
          name: 'blood_amount',
          placeholder: 'Enter Amount',
          required: true,
          extraContent:'ml'
        }
  ];
  return (
    <Box>
      <form onSubmit={formik.handleSubmit}>
        <Grid container spacing={2} className="mb-3">
          {formOptions.map((props, key) => (
            <Grid key={key} item xs={12}>
              <FormikControl formik={formik} {...props} />
            </Grid>
          ))}
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <LoadingButton
              fullWidth
              type="submit"
              variant="contained"
              // loading={isLoading}
              sx={{ backgroundColor: "#3571FF" }}
            >
             Submit
            </LoadingButton>
          </Grid>
        </Grid>
      </form>
    </Box>
  );
};

export default StartManufacturingForm;
